import { AsyncPipe } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, DestroyRef, signal, Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i1 from '@taiga-ui/core';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { TUI_EDITOR_OPTIONS, TUI_EDITOR_TOOLBAR_TEXTS } from '@taiga-ui/editor/common';
import { TuiTiptapEditorService } from '@taiga-ui/editor/directives';
import { map, distinctUntilChanged } from 'rxjs';
let TuiTableMergeCells = /*#__PURE__*/(() => {
  class TuiTableMergeCells {
    constructor() {
      this.localEditor = null;
      this.destroyRef = inject(DestroyRef);
      this.options = inject(TUI_EDITOR_OPTIONS);
      this.injectionEditor = inject(TuiTiptapEditorService, {
        optional: true
      });
      this.texts$ = inject(TUI_EDITOR_TOOLBAR_TEXTS);
      this.canMergeCells = signal(false);
      this.canSplitCells = signal(false);
    }
    set inputEditor(value) {
      this.localEditor = value;
      this.initStream();
    }
    ngOnInit() {
      this.initStream();
    }
    mergeCells() {
      this.editor?.mergeCells();
    }
    splitCell() {
      this.editor?.splitCell();
    }
    get editor() {
      return this.injectionEditor ?? this.localEditor;
    }
    initStream() {
      this.editor?.stateChange$.pipe(map(() => this.editor?.canMergeCells() ?? false), distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)).subscribe(e => this.canMergeCells.set(e));
      this.editor?.stateChange$.pipe(map(() => this.editor?.canSplitCells() ?? false), distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)).subscribe(e => this.canSplitCells.set(e));
    }
    static {
      this.ɵfac = function TuiTableMergeCells_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTableMergeCells)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiTableMergeCells,
        selectors: [["tui-table-merge-cells"]],
        inputs: {
          inputEditor: [0, "editor", "inputEditor"]
        },
        decls: 6,
        vars: 12,
        consts: [["appearance", "icon", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "type", "button", 3, "click", "disabled", "iconStart", "tuiHint"]],
        template: function TuiTableMergeCells_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵlistener("click", function TuiTableMergeCells_Template_button_click_0_listener() {
              return ctx.canMergeCells() ? ctx.mergeCells() : ctx.splitCell();
            });
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵpipe(5, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_2_0;
            let tmp_3_0;
            i0.ɵɵproperty("disabled", !ctx.canMergeCells() && !ctx.canSplitCells())("iconStart", ctx.canMergeCells() ? ctx.options.icons.tableCellMerge : ctx.options.icons.tableCellSplit)("tuiHint", ctx.canMergeCells() ? (tmp_2_0 = i0.ɵɵpipeBind1(1, 4, ctx.texts$)) == null ? null : tmp_2_0.mergeCells : (tmp_2_0 = i0.ɵɵpipeBind1(2, 6, ctx.texts$)) == null ? null : tmp_2_0.splitCells);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.canMergeCells() ? (tmp_3_0 = i0.ɵɵpipeBind1(4, 8, ctx.texts$)) == null ? null : tmp_3_0.mergeCells : (tmp_3_0 = i0.ɵɵpipeBind1(5, 10, ctx.texts$)) == null ? null : tmp_3_0.splitCells, "\n");
          }
        },
        dependencies: [AsyncPipe, TuiButton, i1.TuiHintDirective, i1.TuiHintDescribe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TuiTableMergeCells;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiTableMergeCells };
